import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Financials_PaymentV3_TransactionRequestModelV3,
  ResponseModels_Financials_PaymentV3_PublicTransactionStatusV3ResponseModel,
  ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type CreatePaymentTransactionForInvoiceFromEncryptedQueryStringV3 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  query: string;
  requestBody: RequestModels_Financials_PaymentV3_TransactionRequestModelV3;
};
/**
 * Creates the payment transaction for invoice from encrypted query string.
 *
 * @returns ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel Success
 */
export function createPaymentTransactionForInvoiceFromEncryptedQueryStringV3(
  { businessUnit, label, query, requestBody }: CreatePaymentTransactionForInvoiceFromEncryptedQueryStringV3,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/v3/${businessUnit}/${label}/payments/invoice`,
      query: { query },
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type CreatePaymentTransactionForPaymentArrangementFromEncryptedQueryStringV3 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  query: string;
  requestBody: RequestModels_Financials_PaymentV3_TransactionRequestModelV3;
};
/**
 * Creates the payment transaction for payment arrangement from encrypted query string.
 *
 * @returns ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel Success
 */
export function createPaymentTransactionForPaymentArrangementFromEncryptedQueryStringV3(
  { businessUnit, label, query, requestBody }: CreatePaymentTransactionForPaymentArrangementFromEncryptedQueryStringV3,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/v3/${businessUnit}/${label}/payments/paymentarrangement`,
      query: { query },
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type GetPaymentTransactionStatusFromEncryptedQueryStringV3 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  paymentId: string;
  query: string;
};
/**
 * Gets the payment transaction status from encrypted query string.
 *
 * @returns ResponseModels_Financials_PaymentV3_PublicTransactionStatusV3ResponseModel Success
 */
export function getPaymentTransactionStatusFromEncryptedQueryStringV3(
  { businessUnit, label, paymentId, query }: GetPaymentTransactionStatusFromEncryptedQueryStringV3,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Financials_PaymentV3_PublicTransactionStatusV3ResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/v3/${businessUnit}/${label}/payments/${paymentId}`,
      query: { query },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
